import { EditorView } from "@codemirror/view"

// Line box of a single editor row, and the vertical padding CodeMirror puts
// above and below the content. Private, so every caller sizing an editor goes
// through `editorHeightForRows` rather than re-deriving the arithmetic.
const LINE_HEIGHT_PX = 16
const CONTENT_PADDING_PX = 8

/**
 * CodeMirror sets no font size of its own, so an editor takes whatever its
 * surroundings inherit down: `text-sm` inside a `Card`, the unstyled root size
 * inside a drawer body. Pinning the size and the line box keeps every editor
 * identical wherever it is mounted, one step below the surrounding form text so
 * a monospace block reads as denser than the labels around it.
 */
export const editorTypographyTheme = EditorView.theme({
  "&": {
    fontSize: "var(--text-xs)",
  },
  ".cm-scroller": {
    lineHeight: `${LINE_HEIGHT_PX}px`,
  },
})

/** Pixel height an editor needs to show `rows` lines of the theme above without scrolling. */
export function editorHeightForRows(rows: number): number {
  return rows * LINE_HEIGHT_PX + CONTENT_PADDING_PX
}
